import "./OurServices.module.css";
import Header from "@/reusable_sections/Header";
import YourSeamlessMigrationStartsHere from "./sections/YourSeamlessMigrationStartsHere";
import ComprehensiveMigrationSolutions from "./sections/ComprehensiveMigrationSolutions";
import Footer from "@/reusable_sections/Footer";
export default function OurServicesPage() {
  return <div>
      <Header />
      <YourSeamlessMigrationStartsHere />
      <ComprehensiveMigrationSolutions />
      <Footer />
    </div>;
}